export default [{
  path: '/myLikes',
  name: 'myLikes',
  meta: {
    index: 26
  },
  qurey:{},
  component: () => import('@/views/myLikes/index'),
}]
